module.exports = __webpack_public_path__ + "static/media/521.2a4bf95f.jpg";